<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oSIac0/tc-custom/9781504055833.jpg?1728726213855" alt="This image is the cover for the book Fred Carver Mysteries Volume Two, The Fred Carver Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fred Carver Mysteries Volume Two, The Fred Carver Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>The second set of crime thrillers starring a tough Florida PI from the <i>New York Times</i>–bestselling author of <i>Single White Female</i> and “one of the masters” (Ridley Pearson).</b><br/>  <br/><i>New York Times</i>– and <i>USA Today</i>–bestselling author John Lutz has been hailed as “a major talent” by John Lescroart, and he “just keeps getting better and better” (Tony Hillerman). “Lutz offers up a heart-pounding roller coaster” (Jeffery Deaver) in his thrillers and “knows how to make you shiver” (Harlan Coben).<br/>  <br/> “The Carver series is the finest work yet by this prolific author” (<i>St. Louis Post-Dispatch</i>). After a criminal’s bullet shattered not only his knee but also his career as an Orlando cop and his marriage, Fred Carver starts over as a private detective. In this award-winning ten-book series, Lutz’s “dogged Carver is a believably heroic guy, tough, scarred and able to exhibit fear and courage at the same time” (<i>Publishers Weekly</i>).<br/>  <br/><i>Flame</i>: When his newest client is killed in a car explosion only minutes after hiring him, Carver learns the man may not have been whom he claimed.<br/>  <br/> “Stunning . . . a brilliant writer, here at the peak of his abilities.” —<i>The Plain Dealer</i><br/>  <br/><i>Bloodfire</i>: Carver is hired by a distraught husband to find his missing wife—a heroin addict who fled with nearly $10,000. But when the terrified woman begs Carver for protection, the truth about his client’s motives comes out, and now both of them must go on the run.<br/>  <br/> “Another satisfying thriller . . . Lutz carefully and caustically captures the heat and amorality of the faces and fixtures of the Florida drug scene.” —<i>The Atlanta Journal-Constitution</i><br/>  <br/><i>Hot</i>: After an old man tells Carver a tale of his wealthy neighbor in the Florida Keys using a yacht to smuggle cocaine, he turns up dead, the victim of a suspicious hit-and-run, and it’s up to the PI to bring his killers to justice.<br/>  <br/> “A fast-paced and well-plotted mystery . . . stays hot until the very last page.” —<i>San Francisco Chronicle</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Lutz
      </h2>
      
      <p class="authorDescription body article">For over forty years, John Lutz (b. 1939) has been one of the premier  voices in contemporary hard-boiled fiction, producing dozens of novels  and over 250 short stories. His earliest success came with the Alo  Nudger series, set in his hometown of St. Louis. <i>Tropical Heat</i> introduced Fred Carver, a Florida detective whom Lutz followed in ten  novels. More recently, he has produced five books in the Frank Quinn  serial killer series. Lutz is a former president of the Mystery Writers  of America, and his many honors include lifetime achievement awards from  the Short Mystery Fiction Society and the Private Eye Writers of  America. He lives in St. Louis.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?76f85e83